import React from 'react';
import { FiExternalLink } from 'react-icons/fi';
import { fmtMovePct, sourceHost } from '../utils/moverNews';
import { formatEventDate } from '../utils/earningsElapsed';
import '../styles/MoverExplanation.css';

/**
 * One stock's "why it moved" block (issue #317), rendered inside the expanded table row above
 * Recent News. Takes the object `explanationFor()` returns, so the row reads the payload through
 * the same accessor as the mobile Brief and the two cannot disagree about which text applies.
 *
 * A theme member shows its theme's title and prose plus the other members it moved with; a
 * company-specific mover shows its own summary; a searched-but-unexplained mover says so in muted
 * text rather than showing nothing, because "we looked and found no news" is itself the answer.
 */
const moveClass = (value) =>
  value == null ? '' : value >= 0 ? 'mover-news__move--up' : 'mover-news__move--down';

const MoverExplanation = ({ explanation }) => {
  if (!explanation) return null;
  const { text, sources, theme, noNews, mover, sessionDate, ticker } = explanation;
  const others = (theme?.tickers || []).filter((t) => t !== ticker);

  return (
    <div className="mover-news">
      <h3 className="company-news-header mover-news__header">
        Why it moved{' '}
        <span className={`mover-news__move ${moveClass(mover.changePercent)}`}>{fmtMovePct(mover.changePercent)}</span>
        {sessionDate && <span className="mover-news__asof"> · {formatEventDate(sessionDate)}</span>}
      </h3>
      {theme && (
        <div className="mover-news__theme-title">
          {theme.title}
          {others.length > 0 && <span className="mover-news__with"> · with {others.join(', ')}</span>}
        </div>
      )}
      <p className={`mover-news__text ${noNews ? 'mover-news__text--muted' : ''}`}>{text}</p>
      {sources?.length > 0 && (
        <div className="mover-news__sources">
          {sources.map((s, i) => (
            <a key={`${s.url}-${i}`} href={s.url} target="_blank" rel="noopener noreferrer" className="mover-news__source">
              <FiExternalLink /> {s.title || sourceHost(s.url)}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};

export default MoverExplanation;
